<template>
  <DropdownItemView v-once aria-role="listitem" has-link v-if="authUser.permission.canAccessNova">
    <a :href="novaUrl" target="_blank">
      <img src="@/assets/logos/cleardesk-logo-responsive.png" alt="cleardesk-logo" />
      {{ $t('Go to Nova') }}
    </a>
  </DropdownItemView>
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import DropdownItemView from '@/modules/core/ui/components/wrappers/DropdownItemView.vue';
import { Env } from '@/Env';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'NovaDropdownItem',
  mixins: [HasAuthUserMixin],
  components: { DropdownItemView },
  computed: {
    novaUrl() {
      return `${Env.nodeEnv().VITE_APP_LOCAL_ORIGIN}/nova/dashboards/main`;
    }
  }
};
</script>

<style scoped>
img {
  position: relative;
  top: var(--ce-5px);
  left: var(--ce-1px);
  width: var(--ce-20px);
  margin-right: var(--ce-3px);
}
</style>
